import { useState } from 'react'
import methodModel from '../../../methods/methods'
import SelectDropdown from '../SelectDropdown'
import './style.scss'
import { Editor } from "@tinymce/tinymce-react";
import tinymcModel from '../../../models/tinymc.model';
import ReactQuill from 'react-quill';
export default function FormControl({
    name,
    divClass=null,
    id = "",
    displayValue = 'name',
    sort=true,
    placeholder = "",
    type = 'text',
    options = [],
    error,
    label,
    required = false,
    onInputChange = (e) => { },
    onChange,
    maxlength = '',
    minlength = '',
    min = '',
    value,
    theme = '',
    disabled = false
}) {


    const [text, setText] = useState('')

    const add = () => {
        let arr = value || []
        if (text) {
            arr.push(text)
        }
        onChange(arr)
        setText('')
    }

    const remove = (i) => {
        let arr = value || []
        arr = arr.filter((itm, index) => index != i)
        onChange(arr)
    }

    const addItem = (v) => {
        let arr = value || []
        let ext = arr?.find((itm) => itm == v)

        if (ext) {
            arr = arr.filter(itm => itm != v)
        } else {
            arr.push(v)
        }

        onChange(arr)
    }

    return <>
        <div className="formWrapper">
            {label ? <>
                <label className='text-sm font-normal text-[#75757A] !mb-2 inline-block'>{label} {required ? <><span className="text-red-500">*</span></> : <></>}</label>
            </> : <></>}

            {type == 'toggle' ? <>
                <div>
                    <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} value="" class="sr-only peer" />
                        <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#115B9D]"></div>
                    </label>
                </div>



            </> : type == 'textarea' ? <>
                <textarea rows={5}
                    name={name}
                    className="relative shadow-box border !border-grey bg-white w-full rounded-large flex items-center gap-2 overflow-hidden p-2 !ring-[#115B9D] !outline-[#115B9D]"
                    required={required}
                    placeholder={placeholder}
                    value={value || ''}
                    maxLength={maxlength}
                    minLength={minlength}
                    min={min}
                    disabled={disabled}
                    onChange={e => onChange(e.target.value)}
                ></textarea>
            </> : type == 'select' ? <SelectDropdown
                id={`statusDropdown_${id}`}
                displayValue={displayValue}
                placeholder={placeholder}
                sort={sort}
                onInputChange={onInputChange}
                intialValue={value || ''}
                name={name}
                theme={theme}
                result={e => { onChange(e.value) }}
                options={options}
                disabled={disabled}
            /> : type == 'number' ? <input
                type="text"
                name={name}
                className="shadow-box border !border-grey bg-white w-full text-sm placeholder:text-gray-500 rounded-large h-10 flex items-center gap-2 overflow-hidden px-4 !ring-[#115B9D] !outline-[#115B9D] relative"
                required={required}
                placeholder={placeholder}
                value={value || ''}
                maxLength={maxlength}
                minLength={minlength}
                min={min}
                disabled={disabled}
                onChange={e => onChange(methodModel.isNumber(e))}
            /> : type == 'badge' ? <>
                <div className='flex'>
                    <input
                        type="text"
                        className="relative shadow-box border !border-grey bg-white w-full rounded-large h-10 flex items-center gap-2 overflow-hidden px-2"
                        placeholder={placeholder} value={text}
                        onChange={e => setText(e.target.value)}
                    />
                    <button type='button' className='btn btn-[#115B9D] ml-2' onClick={add}>Add</button>
                </div>
                <div className=''>
                    {value?.map((itm, i) => {
                        return <span className='badge badge-[#115B9D] m-1'>
                            {itm}
                            <i className='fa fa-times ml-1' onClick={() => remove(i)}></i>
                        </span>
                    })}

                </div>
            </> : type == 'radio' ? <>
                <div className='flex flex-wrap gap-3'>
                    {options.map(itm => {
                        return <label className="text-typo cursor-pointer mb-0 text-sm font-medium flex items-center gap-1.5 hover:text-[#115B9D]   group">
                            <input type="radio"
                                checked={value == itm.id ? true : false}
                                onChange={e => onChange(itm.id)}
                                className="h-4 w-4 checked:!ring-[#115B9D] checked:ring-0 ring-offset-1 cursor-pointer shrink-0 rounded-full border-[1.6px] border-[#3C3E4966] group-hover:border-[#115B9D] !text-[#115B9D]  " name={name} disabled={disabled} />
                            {itm.name}</label>
                    })}
                </div>

            </> : type == 'editor' ? <>
                <ReactQuill theme="snow"
                    className="quillreacts resize-y overflow-auto min-h-[150px] h-[250px]"

                    value={value}
                    onChange={newValue => {
                        onChange(newValue)
                    }
                    } />
            </> : type == 'checkbox' ? <>
                {options.map(itm => {
                    return <label className="flex">
                        <input type="checkbox"
                            checked={value?.includes(itm.id) ? true : false}
                            onChange={e => addItem(itm.id)}
                            className="mr-2" disabled={disabled} />
                        {itm.name}</label>
                })}
            </> : type == 'date' ? <>
                <input
                    type="date"
                    name={name}
                    className="relative shadow-box border !border-grey bg-white w-full rounded-large h-10 flex items-center gap-2 overflow-hidden px-2 !ring-[#115B9D] !outline-[#115B9D]"
                    required={required}
                    placeholder={placeholder}
                    value={value?.split('T')?.[0]}
                    maxLength={maxlength}
                    minLength={minlength}
                    min={min}
                    disabled={disabled}
                    onChange={e => onChange(e.target.value)}
                />
            </> : <input
                type={type}
                name={name}
                className="shadow-box border !border-grey bg-white w-full text-sm placeholder:text-gray-500 rounded-large h-10 flex items-center gap-2 overflow-hidden px-4 !ring-[#115B9D] !outline-[#115B9D]"
                required={required}
                placeholder={placeholder}
                value={value || ''}
                maxLength={maxlength}
                minLength={minlength}
                min={min}
                disabled={disabled}
                onChange={e => onChange(e.target.value)}
            />
            }

            {error ? <>
                <div className='text-danger small mt-1'>{error}</div>
            </> : <></>}
        </div>
    </>
}